// extracted by mini-css-extract-plugin
module.exports = {"dataCell":"tableCell__dataCell___1JpHZ","large":"tableCell__large___3l_Wa","medium":"tableCell__medium___60UOl","small":"tableCell__small___2MZom"};